// Utility to build report query strings for report downloads
import { isNil } from 'ramda';

/**
 * Builds a query string for report downloads based on provided params.
 * @param {Object} params
 * @returns {string}
 */
export function buildReportQuery({
  period,
  startDate,
  endDate,
  startPeriod,
  endPeriod,
  scheduledPeriod,
  actualPeriod,
  currentPeriod,
  futurePeriod,
  date,
  customDateField,
  leaseType,
  query,
}) {
  const periodQuery = `?period=${period}`;
  const rangeQuery = `?startDate=${startDate}&endDate=${endDate}`;
  const periodRangeQuery = `?startPeriod=${startPeriod}&endPeriod=${endPeriod}`;
  const dateQuery = `?date=${date}`;
  const scheduledActualPeriodQuery = `?scheduledPeriod=${scheduledPeriod}&actualPeriod=${actualPeriod}`;
  const currentAndFuturePeriodQuery = `?currentPeriod=${currentPeriod}&futurePeriod=${futurePeriod}`;

  let finalQuery = '';
  if (!isNil(period)) {
    finalQuery = periodQuery;
  } else if (!isNil(startDate)) {
    finalQuery =
      rangeQuery +
      (isNil(customDateField) ? '' : `&customDateField=${customDateField}`);
  } else if (!isNil(date)) {
    finalQuery = dateQuery;
  } else if (!isNil(startPeriod)) {
    finalQuery = periodRangeQuery;
  } else if (!isNil(scheduledPeriod)) {
    finalQuery = scheduledActualPeriodQuery;
  } else if (!isNil(futurePeriod)) {
    finalQuery = currentAndFuturePeriodQuery;
  }

  if (leaseType) finalQuery += `&leaseType=${leaseType}`;

  if (query) {
    finalQuery += finalQuery ? `&${query}` : `?${query}`;
  }

  return finalQuery;
}
